export default __webpack_public_path__ + "static/media/qr1.107d7fba.png";